/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cognito_identity_pool_id": "us-west-1:e7790af7-a872-441c-9ba8-e30899a02a04",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_kZoBGq3w7",
    "aws_user_pools_web_client_id": "39tuimo3itt8rijkcjecbh8epi",
    "oauth": {
        "domain": "cabinetv2tvmarkets5d14fd67-5d14fd67-prod.auth.us-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://cabinet.tvmarkets.com/login/",
        "redirectSignOut": "https://cabinet.tvmarkets.com/login/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
